module.exports = "https://cdn.realtymogul.com/static/media/img_panel_passive.bb8fe9e1.jpg";